module.exports = __webpack_public_path__ + "img/app-logo.d9b61bfa.svg";